<template>
  <div class="app-usos-container p-2">
    <b-card>
      <b-row class="mb-2" align-v="center">
        <b-col md="4">
          <h4 class="mb-0">Uso de App por Usuario</h4>
        </b-col>
        <b-col md="3">
          <v-select
            v-model="filtroUsuario"
            :options="listaUsuarios"
            placeholder="Filtrar por usuario..."
            :clearable="true"
          />
        </b-col>
        <b-col md="3">
          <div class="d-flex align-items-center" style="gap: 8px;">
            <span style="white-space: nowrap;">Desde</span>
            <flat-pickr v-model="filtroFechaDesde" class="form-control" />
          </div>
        </b-col>
        <b-col md="2" class="d-flex align-items-center justify-content-end" style="gap: 8px;">
          <b-form-checkbox v-model="ocultarPablo" switch>
            Ocultar Pablo
          </b-form-checkbox>
          <small class="text-muted">{{ datosFiltrados.length }}</small>
        </b-col>
      </b-row>

      <b-table
        :items="datosFiltrados"
        :fields="columnas"
        hover
        striped
        responsive
        sort-icon-left
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
        empty-text="No hay datos de uso"
      >
        <template #cell(uso)="data">
          <b-badge variant="light-primary">
            {{ Math.round(data.item.uso) }}
          </b-badge>
        </template>

        <template #cell(fecha)="data">
          {{ formatFecha(data.item.fecha) }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    vSelect,
    flatPickr,
  },
  data() {
    return {
      datos: [],
      filtroUsuario: this.$route.query.usuario || null,
      filtroFechaDesde: new Date().toISOString().slice(0, 10),
      ocultarPablo: false,
      sortBy: 'uso',
      sortDesc: true,
      columnas: [
        {
          key: 'usuario_nombre',
          label: 'Usuario',
          sortable: true,
        },
        {
          key: 'seccion',
          label: 'Seccion',
          sortable: true,
        },
        {
          key: 'uso',
          label: 'Uso',
          sortable: true,
          thStyle: { width: '120px', textAlign: 'center' },
          tdClass: 'text-center',
        },
        {
          key: 'fecha',
          label: 'Ultima fecha',
          sortable: true,
          thStyle: { width: '160px' },
        },
      ],
    }
  },
  computed: {
    listaUsuarios() {
      const nombres = this.datos
        .map(d => d.usuario_nombre)
        .filter(Boolean)
      return [...new Set(nombres)].sort()
    },
    datosFiltrados() {
      let resultado = this.datos
      if (this.ocultarPablo) {
        resultado = resultado.filter(d => d.usuario_nombre !== 'Pablo')
      }
      if (this.filtroUsuario) {
        resultado = resultado.filter(d => d.usuario_nombre === this.filtroUsuario)
      }
      if (this.filtroFechaDesde) {
        const desde = new Date(this.filtroFechaDesde + 'T00:00:00')
        resultado = resultado.filter(d => {
          if (!d.fecha) return false
          return new Date(d.fecha) >= desde
        })
      }
      return resultado
    },
  },
  methods: {
    load() {
      axios
        .get('/uso')
        .then(response => {
          this.datos = response.data
        })
        .catch(e => {
          console.error('Error cargando usos:', e)
        })
    },
    formatFecha(fecha) {
      if (!fecha) return '-'
      const d = new Date(fecha)
      return d.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';
@import '../@core/scss/vue/libs/vue-flatpicker.scss';

.app-usos-container {
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f8f8f8;
}

// Modo oscuro
.dark-layout .app-usos-container {
  background: #161616;
}
</style>
